// ==============================|| CLEANING ICON ||============================== //

const CleaningIcon = ({ color = '#000', width = 24, className = '' }) => {
  const commonStyle = {
    fill: color,
    strokeWidth: '0px',
  };

  return (
    <svg
      width={width}
      height={width}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M4,21.7c-.8,0-1.4-.3-1.9-.8s-.8-1.2-.8-1.9.3-1.4.8-1.9,1.2-.8,1.9-.8,1.4.3,1.9.8.8,1.2.8,1.9-.3,1.4-.8,1.9-1.2.8-1.9.8ZM4,20.2c.3,0,.6-.1.9-.4.2-.2.4-.5.4-.9s0-.6-.4-.9c-.2-.2-.5-.4-.9-.4s-.6.1-.9.4c-.2.2-.4.5-.4.9s0,.6.4.9c.2.2.5.4.9.4ZM7.9,21.7c.2-.2.3-.5.4-.7s.2-.5.3-.8h2.3v-7.3c0-.6-.2-1.1-.7-1.6s-1-.7-1.6-.7H3.8v3.5h-.8c-.3,0-.5.1-.7.2v-5.3h3v-3.7c0-1.2.4-2.2,1.3-3.1.8-.8,1.9-1.3,3.1-1.3s1.7.2,2.4.7,1.3,1.1,1.6,1.9l6.9,16.4h2.2v1.5h-6.5v-1.5h2.6l-6.6-15.7c-.2-.5-.6-1-1.1-1.3s-1-.5-1.6-.5-1.5.3-2,.8-.8,1.2-.8,2v3.7h1.9c1,0,1.9.4,2.7,1.1.7.7,1.1,1.6,1.1,2.7v8.8h-4.5v.2Z"
        style={commonStyle}
      />
    </svg>
  );
};

export default CleaningIcon;
